import { useAuth } from '../contexts/AuthContext';
import React from 'react';
import Layout from '../components/Layout';
import AssessmentTabs from '../components/AssessmentTabs';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { assessmentsService } from '../api/assessmentsService';

const Assessments: React.FC = () => {
  const { user } = useAuth();
  const canManage = user?.roles?.some(r => ['admin','assessment-admin'].includes(typeof r === 'string' ? r : r.name));
  const { data, isLoading, error } = useQuery({
    queryKey: ['assessments'],
    queryFn: () => assessmentsService.list(),
  });

  return (
    <Layout>
      <div className="space-y-6">
        <div className="bg-white shadow-sm rounded-xl p-4 sm:p-6 space-y-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Assessments</h1>
            <p className="text-gray-600 mt-2">
              View assessment events and the portal candidates assigned to each.
            </p>
          </div>
          <AssessmentTabs />
          {canManage && <div className="flex gap-4"><Link className="bg-primary-600 text-white rounded px-3 py-2" to="/assessments/new">Create assessment</Link><Link className="underline text-primary-700" to="/assessments/assessors">Manage assessors</Link></div>}
        </div>

        {isLoading && (
          <div className="bg-white shadow-sm rounded-xl p-4 sm:p-6 text-gray-700">
            Loading…
          </div>
        )}

        {error && (
          <div className="bg-white shadow-sm rounded-xl p-4 sm:p-6 text-red-700">
            Failed to load assessments.
          </div>
        )}

        {!isLoading && !error && (
          <div className="bg-white shadow-lg rounded-xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Name</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Date</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Location</th>
                    <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Action</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {(data?.data || []).map((a) => (
                    <tr key={a.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">{a.name}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {new Date(a.date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">{a.location || '—'}</td>
                      <td className="px-4 py-3 text-right">
                        <Link
                          to={canManage ? `/assessments/${a.id}/manage` : `/assessments/${a.id}`}
                          className="inline-flex items-center px-3 py-2 rounded-md bg-primary-600 text-white hover:bg-primary-700 text-sm"
                        >
                          {canManage ? 'Manage' : 'View'}
                        </Link>
                      </td>
                    </tr>
                  ))}
                  {(data?.data || []).length === 0 && (
                    <tr>
                      <td className="px-4 py-6 text-sm text-gray-600" colSpan={4}>
                        No assessments found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Assessments;

